import { render, staticRenderFns } from "./ImpresionReceta.vue?vue&type=template&id=40e00015"
import script from "./ImpresionReceta.vue?vue&type=script&lang=js"
export * from "./ImpresionReceta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports